var _defs, _path, _path2, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1006",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1007"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 32 40",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A4.81,4.81,0,0,0,0,7.57v9.82A4.81,4.81,0,0,0,5,22H20.34a3.28,3.28,0,0,1,2.16.79l7.83,7A1,1,0,0,0,32,29V7.57A4.81,4.81,0,0,0,27,3Zm3,23.77-6.16-5.5a5.23,5.23,0,0,0-3.5-1.3H5a2.81,2.81,0,0,1-3-2.57V7.57A2.81,2.81,0,0,1,5,5H27a2.81,2.81,0,0,1,3,2.57Z",
    fill: "#ffffff",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7a1 1 0 00-1 1v5a1 1 0 002 0V8A1 1 0 0016 7zM16.71 16.29a1 1 0 00-1.42 0 1.15 1.15 0 00-.21.33.94.94 0 000 .76 1.16 1.16 0 00.21.33 1 1 0 001.42 0 1.16 1.16 0 00.21-.33.94.94 0 000-.76A1.15 1.15 0 0016.71 16.29z",
    fill: "#ffffff",
    className: "color000 svgShape"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    y: 47,
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif",
    fontSize: 5,
    fontWeight: "bold",
    svgjsData: "{\"leading\":\"1.3\"}"
  }, "Created by Kantor Tegalsari")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    y: 52,
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif",
    fontSize: 5,
    fontWeight: "bold",
    svgjsData: "{\"leading\":\"1.3\"}"
  }, "from the Noun Project")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplain);
export default __webpack_public_path__ + "static/media/complain.8183d182a7749435c5dbff614e900710.svg";
export { ForwardRef as ReactComponent };